import { TFunction } from 'i18next';
import _get from 'lodash/get';
import _isFunction from 'lodash/isFunction';
import { SelectOption } from './types';

export function getComparableKey(option: SelectOption, fallbackIndex?: number) {
  if (option?.id) return option.id;
  const rawValue = _get(option, 'value');
  const rawType = typeof rawValue;
  if (rawType === 'string' || rawType === 'number' || rawType === 'boolean') {
    return `${rawValue}`;
  }
  if (rawValue && rawType === 'object') {
    try {
      return JSON.stringify(rawValue);
    } catch {
      return `option-${fallbackIndex ?? 0}`;
    }
  }
  return `option-${fallbackIndex ?? 0}`;
}

export function getOptionLabel(
  option: SelectOption,
  t: TFunction<'translation', undefined>,
) {
  if (option?.labelKey) return t(option.labelKey);
  const label = _get(option, 'label');
  if (_isFunction(label)) {
    // @ts-ignore
    return `${label()}`;
  }
  return `${label}`;
}

export function createSelectedOptionsMap(
  selectedOptions: SelectOption[],
): Map<string, SelectOption> {
  const entries: Array<[string, SelectOption]> = selectedOptions.map(
    (option, index) => [getComparableKey(option, index), option],
  );
  return new Map<string, SelectOption>(entries);
}
